import React, { useMemo } from "react";
import { PieChart as PieChartComponent } from "components/Cards/PieChart";

interface ChartsData {
  subscribersByPlan: { premium: number; pro: number; enterprise: number };
  trialsByOrigin: { ios: number; stripe: number; square: number };
  trialsByPlan: { premium: number; pro: number; enterprise: number };
  subscribersByOrigin: { ios: number; stripe: number; square: number };
}

interface PieChartsGridProps {
  chartsData: ChartsData;
  isLoading: boolean;
}

export const PieChartsGrid = React.memo(({ chartsData, isLoading }: PieChartsGridProps) => {
  const subscribersByPlanSeries = useMemo(
    () => [chartsData.subscribersByPlan.premium, chartsData.subscribersByPlan.pro, chartsData.subscribersByPlan.enterprise],
    [chartsData.subscribersByPlan]
  );

  const trialsByOriginSeries = useMemo(
    () => [chartsData.trialsByOrigin.ios, chartsData.trialsByOrigin.stripe, chartsData.trialsByOrigin.square],
    [chartsData.trialsByOrigin]
  );

  const trialsByPlanSeries = useMemo(
    () => [chartsData.trialsByPlan.premium, chartsData.trialsByPlan.pro, chartsData.trialsByPlan.enterprise],
    [chartsData.trialsByPlan]
  );

  const subscribersByOriginSeries = useMemo(
    () => [chartsData.subscribersByOrigin.ios, chartsData.subscribersByOrigin.stripe, chartsData.subscribersByOrigin.square],
    [chartsData.subscribersByOrigin]
  );

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <PieChartComponent
        title="Subscribers by Plan"
        series={subscribersByPlanSeries}
        colors={["#388e3c", "#0288d1", "#f44336"]}
        labels={["Premium", "Pro", "Enterprise"]}
        isLoading={isLoading}
      />
      <PieChartComponent
        title="Trials by Plan"
        series={trialsByPlanSeries}
        colors={["#388e3c", "#0288d1", "#f44336"]}
        labels={["Premium", "Pro", "Enterprise"]}
        isLoading={isLoading}
      />
      <PieChartComponent
        title="Subscribers by Origin"
        series={subscribersByOriginSeries}
        colors={["#B2B2BA", "#675DFF", "#000000"]}
        labels={["iOS", "Stripe", "Square"]}
        isLoading={isLoading}
      />
      <PieChartComponent
        title="Trials by Origin"
        series={trialsByOriginSeries}
        colors={["#B2B2BA", "#675DFF", "#000000"]}
        labels={["iOS", "Stripe", "Square"]}
        isLoading={isLoading}
      />
    </div>
  );
});
